import { useState } from 'react';

/**
 * Custom hook to manage all state for the Node Editor
 */
export const useNodeEditorState = () => {
  // Core editor state
  const [steps, setSteps] = useState([]);
  const [flowItems, setFlowItems] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedPanel, setDraggedPanel] = useState(null);
  const [dragOverPosition, setDragOverPosition] = useState(null);
  const [dragOverStep, setDragOverStep] = useState(null);
  const [animatingPanels, setAnimatingPanels] = useState([]);
  
  // View state
  const [panOffset, setPanOffset] = useState({ x: -500, y: -500 });
  const [zoom, setZoom] = useState(1);
  const [isPanning, setIsPanning] = useState(false);
  const [lastPanPoint, setLastPanPoint] = useState({ x: 0, y: 0 });
  const [lockedZoomCenter, setLockedZoomCenter] = useState(null);
  
  // Selection state
  const [selectedItem, setSelectedItem] = useState(null);
  const [expandedComponents, setExpandedComponents] = useState(new Map());
  
  // Sidebar state
  const [activeTab, setActiveTab] = useState('layers');
  const [layers, setLayers] = useState([]);
  const [expandedLayers, setExpandedLayers] = useState(new Set());
  
  // Timeline state
  const [timelineHeight, setTimelineHeight] = useState(280);
  const [isResizingTimeline, setIsResizingTimeline] = useState(false);
  
  // Stacking order state
  const [isStackingMode, setIsStackingMode] = useState(false);
  const [stackingOrder, setStackingOrder] = useState([]);
  const [draggedStackItem, setDraggedStackItem] = useState(null);
  const [dragOverStackItem, setDragOverStackItem] = useState(null);
  const [hoveredStackingItem, setHoveredStackingItem] = useState(null);
  
  // Component drag state
  const [draggedComponent, setDraggedComponent] = useState(null);
  const [draggedComponentSourceStep, setDraggedComponentSourceStep] = useState(null);
  
  // Editing state
  const [isEditingName, setIsEditingName] = useState(false);
  
  // Expansion connector lines state
  const [showExpansionLines, setShowExpansionLines] = useState(true);
  
  // Multi-flow state
  const [flows, setFlows] = useState([
    { id: 'primary', name: 'Primary', flowItems: [], steps: [], stackingOrder: [] }
  ]);
  const [activeFlowId, setActiveFlowId] = useState('primary');
  const [showFlowNameModal, setShowFlowNameModal] = useState(false);

  return {
    // Core state
    steps, setSteps,
    flowItems, setFlowItems,
    draggedItem, setDraggedItem,
    draggedPanel, setDraggedPanel,
    dragOverPosition, setDragOverPosition,
    dragOverStep, setDragOverStep,
    animatingPanels, setAnimatingPanels,
    
    // View state
    panOffset, setPanOffset,
    zoom, setZoom,
    isPanning, setIsPanning,
    lastPanPoint, setLastPanPoint,
    lockedZoomCenter, setLockedZoomCenter,
    
    // Selection state
    selectedItem, setSelectedItem,
    expandedComponents, setExpandedComponents,
    
    // Sidebar state
    activeTab, setActiveTab,
    layers, setLayers,
    expandedLayers, setExpandedLayers,
    
    // Timeline state
    timelineHeight, setTimelineHeight,
    isResizingTimeline, setIsResizingTimeline,
    
    // Stacking order state
    isStackingMode, setIsStackingMode,
    stackingOrder, setStackingOrder,
    draggedStackItem, setDraggedStackItem,
    dragOverStackItem, setDragOverStackItem,
    hoveredStackingItem, setHoveredStackingItem,
    
    // Component drag state
    draggedComponent, setDraggedComponent,
    draggedComponentSourceStep, setDraggedComponentSourceStep,
    
    // Editing state
    isEditingName, setIsEditingName,
    
    // Expansion connector lines state
    showExpansionLines, setShowExpansionLines,
    
    // Multi-flow state
    flows, setFlows,
    activeFlowId, setActiveFlowId,
    showFlowNameModal, setShowFlowNameModal,
  };
};
